<template>
    <div class="absolute w-screen">
        <div ref="wrapper" class="mx-auto w-[95vw] h-[85vh]">
            <svg :viewBox="`0 0 1920 1080`" id="svg_chart" class="px-4">
                <g>
                    <path :fill="filteredColor(d)" :stroke="filteredColor(d)" v-for="d in this.geodata" :key="d.properties.COD_AED" :d="geoGenerator(d.geometry)"></path>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import * as d3 from 'd3'

import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../tailwind.config.js'
const fullConfig = resolveConfig(tailwindConfig)

export default {
    // 1. Access and parse data (data(), as a prop)
    // 2. Create chart dimensions (computed, because of resizing)?
    // 3. Render chart (template)
    // 4. Create scales (computed, bcause of data change)
    // 5. Render data (computed, bcause of data change)
    // 6. Render peripherals (computed, because of data change or resizing)
    // 7. Create and add interactions (template and computed)

    data() {
        return {
            publicPath: process.env.BASE_URL,
            dataset: null,
            geodata: null,
            mapdata: null,
            hovered: null,
            projection: null,
            chartLoaded: false,

            size: {
                width: 1200,
                height: 500,
                pad: 0.5,
                margin: {
                    left: 180,
                    right: 60,
                    top: 10,
                    bottom: 30,
                },
            },
            colors: {
                map_high: fullConfig.theme.colors['map_high'],
                map_mid: fullConfig.theme.colors['map_mid'],
                map_low: fullConfig.theme.colors['map_low'],
            },

            tooltipPos: {
                x: 0,
                y: 0,
            },
        }
    },

    async mounted() {
        const dataset = await d3.csv(this.publicPath + 'static/resumo-executivo/data/14_Colab-int.csv')
        const geodata = await d3.json(this.publicPath + 'static/resumo-executivo/geo/custom.geo.json')
        this.dataset = dataset
        this.mapdata = geodata
        this.geodata = geodata.features
        this.dataLoaded = true

        // .scale(this.size.width / 5)
        // .translate([this.size.width / 5 / 2, this.size.height / 5 / 2])
        this.init()
    },
    methods: {
        // Initialize functions
        init: function () {
            var res = this.dataset.sort(({ 'Numero processos': a }, { 'Numero processos': b }) => b - a)
            for (let i in res) {
                res[i]['ordem'] = i
            }
            this.dataset = res
            this.setSizes()
            this.projection = d3.geoMercator().fitSize([this.size.width, this.size.height], this.mapdata)
        },

        // Sizes
        setSizes: function () {
            this.size.height = this.$refs.wrapper.clientHeight
            this.size.width = this.$refs.wrapper.clientWidth

            let padBetweenNo = this.dataset.length - 1
            let padBetweenWidth = (this.bounds.width / 100) * this.size.pad
            let padBetweenTotal = padBetweenNo * padBetweenWidth
            let rectWidth = (this.bounds.width - padBetweenTotal) / this.dataset.length

            this.size.rectWidth = rectWidth
            this.size.padBetweenWidth = padBetweenWidth
        },

        // Map
        geoGenerator: function (d) {
            const path = d3.geoPath().projection(this.projection)

            return path(d)
        },

        // Accessors
        featureAccessor: function (d) {
            let val = d.properties['iso_a3']
            return val
        },

        isoAccessor: function (d) {
            let val = d['ISO']
            return val
        },

        fillAccessor: function (d) {
            let val = parseInt(d['ordem'])
            return val
        },

        filteredColor: function (d) {
            let featureColor
            let val
            for (let i = 0; i < this.dataset.length - 1; i++) {
                let featureISO = this.featureAccessor(d)
                if (featureISO == this.isoAccessor(this.dataset[i])) {
                    val = this.fillAccessor(this.dataset[i])
                    break
                }
            }
            if (val == undefined) {
                featureColor = 'gray'
            } else {
                featureColor = this.fillScale(val)
            }
            return featureColor
        },

        // Scales
        fillScale: function (d) {
            // console.log(d3.extent(this.dataset, this.fillAccessor))
            const fillScale = d3.scaleLinear().domain([0, 52, 104]).range([this.colors.map_high, this.colors.map_mid, this.colors.map_low])
            return d ? fillScale(d) : fillScale
        },

        // Animation
    },
    watch: {},

    computed: {
        // Calculate bounds based on window size
        bounds: function () {
            return {
                width: this.size.width - this.size.margin.left - this.size.margin.right,
                height: this.size.height - this.size.margin.top - this.size.margin.bottom,
            }
        },
    },
}
</script>
